import { render, staticRenderFns } from "./ProductsChipGroup.vue?vue&type=template&id=0830053b&scoped=true&"
import script from "./ProductsChipGroup.vue?vue&type=script&lang=ts&"
export * from "./ProductsChipGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsChipGroup.vue?vue&type=style&index=0&id=0830053b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830053b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol})
